<template>
  <div class="crop-card">
    <!-- <div class="crop-card-title" v-for="item in card" :key="item.name">{{item.name}}</div> -->
    <div class="crop-card-methods" v-for="item in card" :key="item.name">
      <span class="crop-card-tag">【{{item.name}}】</span><br>
      <span>
        {{item.text}}
      </span>
    </div>
    <!-- <div class="crop-card-desc">
      <span class="crop-card-tag">【使用说明】</span>
      <div v-html="card.growExplain" style="padding-left:6px;">
        
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  props: ['card'],
  methods: {},
};
</script>
<style lang="scss" scoped>
.crop-card {
  width: 100%;
  padding: 18px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e6e6e6;
  margin-bottom: 16px;
  &:last-child{
      margin-bottom: 0;
  }
  .crop-card-title {
    font-size: 18px;
    color: #1f1f1f;
    margin-bottom: 12px;
  }
  .crop-card-methods {
    width: 100%;
    overflow: hidden;
    color: #1f1f1f;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 12px;
  }
  .crop-card-desc {
    width: 100%;
    overflow: hidden;
    color: #1f1f1f;
    line-height: 20px;
    font-size: 14px;
  }
  .crop-card-tag {
    font-size: 14px;
    font-weight: bold;
    color: #333;
  }
}
</style>
